<div>
	<div class="activity-overview-header">
		<h2 class="activity-overview-title">{{ 'activity-overview' | translate }}</h2>
		@if (shouldShowEditButton()) {
			<button
				type="button"
				class="btn link-btn edit-btn"
				(click)="editActivity()">
					<span class="task-details-edit-button-icon ficon-app-edit" aria-hidden="true"></span>
					{{ 'common_edit' | translate}}
			</button>
		}
	</div>
	@if (activity) {
		<activity-info
			[activity]="activity"
			[viewFrom]="viewFrom.ACTIVITY_OVERVIEW"
			[hideNumOfAttempts]="true"
			[hideTimeLimit]="true"
			[hidePoints]="true"
			[hideInstructions]="true"
			[hideSourceMedia]="true"
			[isOnDashboard]="true">
		</activity-info>
	}
</div>
